import { PRODUCT_NOT_FOUND_IMG } from "@const/products.const";
import { Product } from "@interfaces/dto/products.dto";
import { numberToMoneyString } from "@utils/numbers.util";
import Link from "next/link";
import Raiting from "../../product-detail/info/Ratings";

interface Props {
  product: Product;
}

const ListItem = ({ product }: Props) => {
  const {
    image,
    name,
    rating_summary,
    reviews_count,
    special_price,
    price,
    url_key,
  } = product;
  return (
    <div className="card">
      <div className="row my-0">
        <div className="col-sm-3 col-card-img my-0">
          <Link href={`/products/${url_key}`}>
            <a>
              <img
                src={image ?? PRODUCT_NOT_FOUND_IMG}
                className="card-img-top d-sm-none"
                alt={product.name}
              />
              <img
                src={image ?? PRODUCT_NOT_FOUND_IMG}
                className="card-img-top d-none d-sm-block"
                alt="Not Found"
              />
            </a>
          </Link>
        </div>
        <div className="col-sm-8 my-0">
          <div className="card-body">
            <Link href={`/products/${url_key}`}>
              <a>
                <h4 className="name">{name}</h4>
              </a>
            </Link>
            <div className="product-rating">
              <Raiting starCount={reviews_count} />
              <span className="align-self-center">{rating_summary}</span>
            </div>
            <p>{name}</p>
            <h5 className="price">
              <span>฿{numberToMoneyString(special_price ?? price, 0)}.-</span>
              {special_price && (
                <del className="mx-1">฿{numberToMoneyString(price, 0)}.-</del>
              )}
            </h5>
            <div className="product-buttons">
              {/* <button className="btn btn-cart">เพิ่มลงรถเข็น</button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListItem;
